import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { history } from '../history'
import { processLogout } from '../actions/acCommon'

import { DropdownMenu } from './DesignFunctions'

class UserDropdown extends Component {
	state = {
		showUserDropdown: false,
	}
	toggleUserDropdown = () => {
		this.setState(state => ({ showUserDropdown: !state.showUserDropdown }))
	}
	logout = () => {
		this.props.dispatch(processLogout())
		history.push('/')
	}
	render() {
		let { t } = this.context
		let { auth, user } = this.props
		let userDropdown
		let { showUserDropdown } = this.state
		if(auth.signedIn) {
			userDropdown = (
				<DropdownMenu
					customClass="UserDropdown"
					title={user.firstName + " " + user.lastName}
					toggleDropdown={this.toggleUserDropdown}
					active={showUserDropdown}
				>
					<div className="dropdown-item" onClick={this.logout}>{t('logout')}</div>
				</DropdownMenu>
			)
		} else {
			userDropdown = <Link className="UserDropdown link" to="/auth/signin">{t("login")}</Link>
		}
		return userDropdown
	}
}

const mapStateToProps = state => ({
	auth: state.metadataReducer.auth,
	user: state.dataReducer.currentUser
})
UserDropdown.contextTypes = { t: PropTypes.func }
export default connect(mapStateToProps)(UserDropdown);



// WEBPACK FOOTER //
// ./src/components/UserDropdown.js